import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-muted no-mobile flex align-center g6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "indicator green" }, null, -1)
const _hoisted_3 = { class: "text-muted bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "indicator red" }, null, -1)
const _hoisted_5 = { class: "text-muted bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, null, -1)
const _hoisted_7 = { class: "text-muted bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.communication.getState() == _ctx.CommunicationState.Running)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.Lang.getI18N("communication.running")), 1)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.communication.getState() == _ctx.CommunicationState.Passed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_4,
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Lang.getI18N("communication.passed")), 1)
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.communication.getState() == _ctx.CommunicationState.Coming)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Lang.getI18N("communication.coming")), 1)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}